
<div class="companyedit-component" data-hook="companyedit-component">
  <div class="row">
    <div class="form-group col-xs-12 col-md-8">
      <label for="compname">Name der Firma/Organisation</label>
      <input type="text" class="form-control" tabindex="0" ng-model="vm.companydata.name" id="compname"
             ng-blur="vm.save()">
    </div>
    <div class="form-group col-xs-12 col-md-4">
      <label for="comptype">Typ</label>
      <select class="form-control" tabindex="0" ng-model="vm.companydata.type" id="comptype" ng-blur="vm.save()">
        <option>Unternehmen</option>
        <option>Verwaltung</option>
        <option>Schule</option>
        <option>Universität</option>
        <option>Heer/Armee</option>
        <option>Polizei</option>
        <option>Kirche</option>
        <option>Partei</option>
        <option>Verein/NGO</option>
        <option>Anderes/Unbekannt</option>
      </select>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-xs-12 col-md-4">
      <label for="compuid">UID</label>
      <input type="text" class="form-control" tabindex="0" ng-model="vm.companydata.uid" id="compuid"
             ng-blur="vm.save()">
    </div>
    <div class="form-group col-xs-12 col-md-4">
      <label for="compfbnr">FBNr.</label>
      <input type="text" class="form-control" tabindex="0" ng-model="vm.companydata.fbnr" id="compfbnr"
             ng-blur="vm.save()">
    </div>
    <div class="form-group col-xs-12 col-md-4">
      <label for="compstnr">SteuerNr.</label>
      <input type="text" class="form-control" tabindex="0" ng-model="vm.companydata.stnr" id="compstnr"
             ng-blur="vm.save()">
    </div>
  </div>
  <div class="row">
    <div class="form-group col-xs-12  col-md-6">
      <label for="compaddr1">Firmensitz - Adresse</label>
      <input type="text" class="form-control" tabindex="0" ng-model="vm.companydata.address1" id="compaddr1"
             ng-blur="vm.save()">
    </div>
    <div class="form-group col-xs-12  col-md-6">
      <label for="compaddr1">Firmensitz - Adresszusatz</label>
      <input type="text" class="form-control" tabindex="0" ng-model="vm.companydata.address2" id="compaddr2"
             ng-blur="vm.save()">
    </div>
  
  </div>
  <div class="row">
    <!-- PLZ & Ort --><!-- TODO: figure out tabindex handling, zipcode componeparentsaveange? -->
    <div class="form-group form-group col-xs-12 col-md-6">
      <zipcode zip="vm.companydata.postcode" city="vm.companydata.city" ti="0" ti2="0" ng-blur="vm.save()"></zipcode>
    </div>
    <div class="form-group col-xs-12  col-md-6">
      <label for="compcountry">Land</label>
      <input type="text" class="form-control" tabindex="0" ng-model="vm.companydata.country" id="compcountry"
             ng-blur="vm.save()">
    </div>
  </div>
  <div class="row">
    <div class="form-group col-xs-12">
      <label for="compnote">Notiz zur Organisation</label>
      <textarea type="text" class="form-control" tabindex="0" ng-model="vm.companydata.note" id="compnote"
                ng-blur="vm.save()"></textarea>
    </div>
  </div>
</div>

